import { styled } from "@mui/material";
import MuiButton from "@mui/material/Button";

const StyledButton = styled(MuiButton)`
  ${({ theme }) => theme.wsc.typography.button};
  &&:focus {
    outline: 0;
  }

  height: 2.286rem;
  background-color: ${(props) => props.theme.wsc.palette.primary[300]};
  color: ${(props) => props.theme.wsc.palette.primary.contrastText};
  min-width: auto;

  :hover {
    background-color: ${(props) => props.theme.wsc.palette.primary[100]};
  }

  :active {
    background-color: ${(props) => props.theme.wsc.palette.primary[500]};
  }

  :disabled {
    background-color: ${(props) => props.theme.wsc.palette.primary[700]};
    color: ${(props) => props.theme.wsc.palette.primary.contrastText};
  }
`;

export const StyledLeftButton = styled(StyledButton)`
  padding: 0;
  text-transform: inherit;
  && {
    border-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
    border-radius: ${(props) =>
      `${props.theme.wsc.radius.m} ${props.theme.wsc.radius.none} ${props.theme.wsc.radius.none} ${props.theme.wsc.radius.m}`};
  }
`;

export const StyledRightButton = styled(StyledButton)`
  width: 2.286rem;
  padding: ${(props) =>
    `${props.theme.wsc.spacing[1]} ${props.theme.wsc.spacing[0]} ${props.theme.wsc.spacing[1]} ${props.theme.wsc.spacing[0]}`};

  && {
    border-radius: ${(props) =>
      `${props.theme.wsc.radius.none} ${props.theme.wsc.radius.m} ${props.theme.wsc.radius.m} ${props.theme.wsc.radius.none}`};
  }
`;

export const StyledRightButtonItem = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.wsc.spacing[0]};
`;

interface IStyledButtonContent {
  $hasIcon?: boolean;
}

export const StyledButtonContent = styled("div")<IStyledButtonContent>`
  padding: ${(props) =>
    `${props.theme.wsc.spacing[1]} ${props.theme.wsc.spacing[2]} ${props.theme.wsc.spacing[1]} ${props.theme.wsc.spacing[2]}`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(props) => props.theme.wsc.spacing[0]};
`;

interface IStyledIconWrapper {
  $hasText?: boolean;
}

export const StyledIconWrapper = styled("div")<IStyledIconWrapper>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $hasText, theme }) =>
    !$hasText &&
    `
    margin-left: -${theme.wsc.spacing[1]};
    margin-right: -${theme.wsc.spacing[1]};`};
`;
